// extracted by mini-css-extract-plugin
module.exports = {"root":"table_root__1dpyE","item":"table_item__3HeNw"};